import { render, staticRenderFns } from "./ShortKey.vue?vue&type=template&id=36e57d30"
import script from "./ShortKey.vue?vue&type=script&lang=js"
export * from "./ShortKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports